import React, { Fragment } from "react";

import img13 from "../../../images/service/Transportation Blockchain Development/1.png";
import img14 from "../../../images/service/Transportation Blockchain Development/2.png";
import img15 from "../../../images/service/Transportation Blockchain Development/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Fleet & Asset Tracking",
    content:
      "Track vehicles, shipments, and logistics assets in real time using blockchain-powered immutable records.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Automation",
    content:
      "Automate freight agreements, payments, and delivery confirmations with transparent smart contracts.",
  },
  {
    icon: sIcon3,
    title: "Supply Chain Transparency",
    content:
      "Ensure end-to-end visibility across transportation networks with secure and auditable data sharing.",
  },
];

const benefits = [
  {
    title: "Improved Operational Transparency",
    description:
      "Blockchain creates a single source of truth for all transportation and logistics activities.",
    icon: sIcon1,
  },
  {
    title: "Reduced Fraud & Disputes",
    description:
      "Immutable records prevent data tampering and reduce disputes between stakeholders.",
    icon: sIcon2,
  },
  {
    title: "Faster Settlements",
    description:
      "Smart contracts automate payments once delivery conditions are met.",
    icon: sIcon3,
  },
  {
    title: "Optimized Logistics Efficiency",
    description:
      "Real-time tracking and automation reduce delays and operational costs.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "How does blockchain help the transportation industry?",
    a: "Blockchain improves transparency, traceability, and automation across transportation and logistics operations.",
  },
  {
    q: "Can blockchain track shipments in real time?",
    a: "Yes, blockchain integrates with IoT and GPS systems to provide reliable, tamper-proof tracking data.",
  },
  {
    q: "Does blockchain reduce logistics disputes?",
    a: "Absolutely. Immutable transaction records minimize conflicts between shippers, carriers, and customers.",
  },
  {
    q: "Is blockchain scalable for large transportation networks?",
    a: "Yes, blockchain solutions can be designed to support high transaction volumes and enterprise-scale operations.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function TransportationBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Transportation Blockchain Development"
        pagesub="Smart, transparent, and secure blockchain solutions for transportation"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Revolutionize Transportation with{" "}
            <span className="gradient-text">Blockchain Technology</span>
          </>
        }
        subtitle={`Enhance logistics transparency, automate operations, and build trust across transportation networks.
Blockchain enables secure data sharing, real-time tracking, and frictionless settlements.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Transportation Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain for Transportation?"
        image={img14}
        paragraphs={[
          "Transportation and logistics ecosystems involve multiple stakeholders, making transparency and data accuracy critical challenges. Traditional systems often suffer from data silos and manual reconciliation.",
          "Blockchain introduces a decentralized ledger that securely records every transaction, enabling real-time visibility, accountability, and trust across the entire transportation lifecycle.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Transportation Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges in Traditional Transportation Systems"
        image={img15}
        paragraphs={[
          "Manual documentation, limited visibility, and lack of coordination often result in shipment delays, disputes, and inefficiencies.",
          "Blockchain addresses these challenges by automating workflows, securing data exchanges, and enabling seamless collaboration between logistics partners.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Transportation"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Transportation Blockchain Solutions"
        subtitle="Built for scalability, security, and operational efficiency"
        features={[
          {
            icon: sIcon1,
            title: "Real-Time Shipment Tracking",
            description:
              "Monitor vehicle movements and cargo status with immutable data records.",
          },
          {
            icon: sIcon2,
            title: "Smart Contract-Based Payments",
            description:
              "Trigger payments automatically upon delivery confirmation.",
          },
          {
            icon: sIcon3,
            title: "Decentralized Data Sharing",
            description:
              "Enable secure data access among transport stakeholders.",
          },
          {
            icon: sIcon4,
            title: "Fraud Prevention",
            description:
              "Prevent data manipulation and unauthorized changes.",
          },
          {
            icon: sIcon5,
            title: "System Interoperability",
            description:
              "Integrate blockchain with existing logistics platforms.",
          },
          {
            icon: sIcon6,
            title: "Scalable Infrastructure",
            description:
              "Support large-scale transportation networks efficiently.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Deep expertise in blockchain for logistics and transportation",
          "Enterprise-ready blockchain architecture",
          "End-to-end implementation and support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
